import React from "react";
import logo from "../../img/logo-02.png";
import { useRef, useContext, useEffect } from "react";
import auth from "../../firebase";
import { MyContext } from "../../context";
import { useNavigate } from 'react-router-dom'
import supabase from "../../Supa";
import ClientNavDropMenu from "./ClientNavDropMenu"

function NavTwo() {

  let navigate = useNavigate()

  const { updateUsersEmail, updateUserName, userName, usersEmail } = useContext(MyContext);
  

  const dropdownRef = useRef();

  async function out(e){


    e.preventDefault()

    try {
    
  
    const { error } = await supabase.auth.signOut()

     
     if (error) throw error
     sessionStorage.removeItem('token')
     navigate('/')
         
    }catch(error){
     console.log(error)
    }
       
}
{/*
  let out = () => {
    auth.signOut();
    window.location.href = "/";
  };*/}

  return (
    <>
      <div className="topbar">
        <nav className="navbar navbar-light topbarWrapper">
          <div style={{ paddingLeft: "11px", paddingTop: "11px"}}>
            <span>
              
            <img
              src={logo}
              className="Login-animation a6"
              style={{ margin: "0 auto 10px", width: "70px" }}
              alt="Login"
            />
            </span>
          </div>
          <div className="topRight">
          <p className="NavName">{userName}</p>
            <img
              src="https://images.pexels.com/photos/3786525/pexels-photo-3786525.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              width={"35px"}
              height={"35px"}
              alt="Profile_image"
              className="topAvatar"
            />
           {/* <div className="topbarIconsContainer">
              <span className="material-symbols-rounded">notifications</span>
              <span className="topIconBag">2 </span>
            </div>*/}


            <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link topbarIconsContainer"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="material-symbols-rounded">notifications</span>
                  <span className="topIconBag">3 </span>
                </div>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <div className="dropdown-item" >
                    notifications
                  </div>
                </div>
              </div>

            
            <div className="topbarIconsContainer divider">



              <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link "
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="material-symbols-rounded">menu</span>
                </div> 
                
                <ClientNavDropMenu />
               


               
              </div>



            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default NavTwo;
